<template>
  <div class="content">
    <NavBar :navBlock='navBlock' :navtitle='navtitle'></NavBar>
    <div class="paddingContent">
      <div class="ListMenu">
        <div class="MenuBtnWrap">
          <div class="btn" @click="$router.push('/addBirthVideo')">新增生日視頻</div>
        </div>
      </div>
      <div class="tableWrap">
        <el-table :data="birthdayVideoList" height='660px' stripe style="width:100%;">
          <template slot="empty">
            <div class="no-data-container">
              <img src="@/assets/images/common/no_data.png" alt="暂无数据" :style="{width:'244px',height:'139px'}">
            </div>
          </template>
          <el-table-column
            v-for="(item, index) in birthdayVideoTable" :key="index"
            :prop="item.prop"
            :label="item.label">
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button @click="editBirthVideo(scope.row.id, scope.row.type)" type="text" >修改</el-button>
              <el-button @click="delBirthVideo(scope.row.id)" type="text" >刪除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paging-block clearfix">
        <el-pagination class="paging fr"
          hide-on-single-page
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="10"
          :pager-count='5'
          layout="prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from '@/components/navBar'
export default {
  data () {
    return {
      navBlock: '新聞',
      navtitle:'生日影片',
      birthdayVideoList: [],
      birthdayVideoTable: [
        {
          prop: 'title',
          label: '生日文案',
          width: ''
        }, {
          prop: 'startTime',
          label: '開始時間',
          width: ''
        }, {
          prop: 'endTime',
          label: '結束時間',
          width: ''
        },{
          prop: 'publishedTime',
          label: '發佈時間',
          width: ''
        },{
          prop: 'link',
          label: '視頻連接',
          width: ''
        }
      ],
      total: 50,
      currentPage: 1,
    }
  },
  created(){
    let _this = this;
    _this.initList()
  },
  methods:{
    initList(){
      let _this = this;
      let param ={
        type: _this.block === '' ? 0 : Number(_this.block),
        page: _this.currentPage,
        size: 10, 
        startTime: (_this.listMenuForm.startTime === ''|| _this.listMenuForm.startTime === null)  ? null  : _this.$formatDate(_this.listMenuForm.startTime),
        endTime: (_this.listMenuForm.startTime === '' || _this.listMenuForm.startTime === null) ? null : _this.$formatDate(_this.listMenuForm.startTime).substring(0,10) + ' 23:59:59'
      };
      _this.$post('/article/article/getArticleList', param ,_this.$GLOBAL.jsonConfig)
        .then((res) => {
          if(res.code==='00000') {
            _this.newsList=res.data.list.forEach(v => {
              // 新闻版块分类
              switch (v.type) {
                case 0:
                  v.block = '全部'
                  v.vip = '非會員'
                  break
                case 3:
                  v.block = '小版工'
                  v.vip = '會員'
                  break
                case 4:
                  v.block = '新聞'
                  v.vip = '非會員'
                  break
                case 7:
                  v.block = '社群'
                  v.vip = '非會員'
                  break
              }
              if (v.status === 1) {
                v.status = '已發佈'
              } else if (v.status === 2) {
                v.status = '待發佈'
              }
            });
            _this.newsList = res.data.list;
            _this.total = res.data.allRow;
          } else {
            _this.$Mint.Toast(res.message)
          }
        })
    },
    handleCurrentChange(val){
      let _this = this
      _this.currentPage = val
      _this.initList()
    },
    // 重置
    reset(){
      let _this = this;
      _this.block= '';

      _this.listMenuForm = {
        startTime: '',
        endTime: ''
      }
      _this.currentPage = 1;
      _this.initList();
    },
    // 搜索生日视频
    search(){
      let _this = this;
      if (_this.block === '' && (_this.listMenuForm.startTime === ''|| _this.listMenuForm.startTime ===null)) {
        _this.$Mint.Toast('請輸入至少一個搜索條件');
        return false;
      }
      _this.currentPage = 1;
      _this.initList()
    },
    editBirthVideo(){
      let _this = this;
      _this.$router.push('/editBirthVideo')
    },
    // 刪除生日視頻
    delBirthVideo(id){
      let _this = this
      this.$confirm('是否刪除該生日視頻?', '提示信息', {
          confirmButtonText: '確認',
          cancelButtonText: '取消',
          center: true,
          closeOnClickModal: false
        }).then(()=> {
          // 确认删除的回调
          _this.$get('/article/deleteNews/' + id, _this.$GLOBAL.jsonConfig)
            .then((res) => {
          if (res.code==='00000') {
            _this.$Mint.Toast({
              message: '删除成功，请稍后',
              duration: 500
            });
            setTimeout(function () {
              _this.block = '';
              _this.initList()             
            }, 500);
          } else {
            _this.$Mint.Toast(res.message);
          };
        });
      })
    },
  },
  components: {
    NavBar
  }
};
</script>
<style lang="less" scoped>
  .content{
    .paddingContent{
      .ListMenu{
        .MenuBtnWrap{
          display: flex;
          justify-content: flex-end;
          .btn:last-child{
            margin-left: 0.2rem;
          }
        }
      }
      .tableWrap {
        width: 100%;
        height: calc(100% - 152px);
        overflow: auto;
        word-break: break-all;

        @media (max-width: 768px) {
          height: calc(100% - 92px);
        }

        @media (max-width: 420px) {
          height: calc(100% - 112px);
        }
      }
    }
  }
  @media screen and (min-width: 769px) {
    .ListMenu{
        display: flex;
        justify-content: space-between;
        .searchForm{
          flex: 1;
          display: flex;
          justify-content: flex-start;
        }
        .MenuBtnWrap{
          flex: 1;
        }
      }
  }
</style>



// WEBPACK FOOTER //
// src/pages/news/birthdayVideo/birthdayVideoList.vue